import React, { useEffect, useRef, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { animateScroll } from 'react-scroll'
import block from 'bem-cn'

import { toggleOverflow } from 'shared/helpers/toggleOverflow'

import { useSlotSession } from 'modules/SlotsRoot/hooks/useSlotSession'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectBackUrl } from 'features/slots/selectors'

import BackButton from '../BackButton/BackButton'
import { FullscreenButton } from '../FullscreenButton/FullscreenButton'
import RouteReplacingSlots from '../RouteReplacingSlots'

import './SlotFrame.scss'

const b = block('slot-frame')

const SlotFrame: React.FC = () => {
  const { push } = useHistory()

  const backUrl = useSelector(selectBackUrl, shallowEqual)
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)

  const frameRef = useRef<HTMLIFrameElement>(null)
  const [isFullscreen, setIsFullscreen] = useState(false)

  const { sessionUrl, demoStart } = useSlotSession()

  useEffect(() => {
    animateScroll.scrollToTop()

    toggleOverflow(true)
    return () => toggleOverflow(false)
  }, [])

  useEffect(() => {
    if (isFullscreen && document.body.requestFullscreen) {
      document.body.requestFullscreen()
    } else if (document.exitFullscreen) {
      document.exitFullscreen()
    }
  }, [isFullscreen])

  return isAuth || demoStart ? (
    <div className={b('wrapper')}>
      <FullscreenButton toggleFullscreen={() => setIsFullscreen(prev => !prev)} />
      <BackButton callback={() => push(backUrl)} />
      <div className={b({ demo: !!demoStart })}>
        <iframe
          ref={frameRef}
          className={b('iframe')}
          width="100%"
          height="100%"
          src={sessionUrl}
          title="iframe"
          allow="fullscreen;display-capture"
        />
      </div>
    </div>
  ) : (
    <RouteReplacingSlots />
  )
}

export default SlotFrame
